<template>
  <div style="max-height: 100px">
    <b-modal size="xl" id="modalMessages" centered hide-header>
      <template #modal-footer>
        <div style="width: 100%; display: flex; justify-content: space-between">
          <button
            class="btnsModal"
            variant="info"
            size="sm"
            @click="handleCloseModalAndClear"
          >
            Fechar
          </button>
          <button
            class="btnsModal btnSave"
            variant="info"
            size="sm"
            @click="saveOrUpdate"
          >
            Salvar
          </button>
        </div>
      </template>
      <div class="mt-3">
        <div class="rowContainer">
          <span>
            <b-icon-card-checklist></b-icon-card-checklist> Nova Mensagem
          </span>
          <div class="rowContent">
            <InputSelect
              style="width: 20% !important"
              label="Tipo"
              labelFixed
              valueField="value"
              textField="text"
              :items="messageTypes"
              :dataSelect.sync="payloadMessage.tipo"
              :dataInput="payloadMessage.tipo"
              :enableIconCreate="false"
              ref="tipo"
            />

            <Input
              label="Título"
              labelFixed
              style="width: 20% !important"
              type="text"
              :dataInput.sync="payloadMessage.titulo"
              placeholder="Informe um título"
              ref="titulo"
            />

            <Input
              label="Descrição"
              labelFixed
              style="width: 80% !important"
              type="text"
              :dataInput.sync="payloadMessage.texto"
              ref="texto"
            />
          </div>
        </div>

        <span class="titleNcm">Mensagens cadastradas</span>
        <div class="ContentTable">
          <table>
            <thead class="headTable">
              <tr style="width: 100%">
                <th style="font-size: 14px; font-weight: 600">Tipo</th>
                <th style="font-size: 14px; font-weight: 600">Título</th>
                <th style="width: 80%; font-size: 14px; font-weight: 600">
                  Descrição
                </th>
                <th
                  style="
                    text-align: center;
                    font-size: 14px;
                    font-weight: 600;
                    padding: 0 10px;
                  "
                >
                  Ações
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="message in allMessages" :key="message.id">
                <td style="text-align: center; font-size: 13px">
                  {{ message.tipo === "geral" ? "Geral" : "MIP" }}
                </td>

                <td style="text-align: center; font-size: 13px">
                  {{ message.titulo }}
                </td>

                <td style="width: 80%; text-align: center; font-size: 13px">
                  {{ message.texto }}
                </td>
                <td
                  style="
                    text-align: center;
                    padding: 0 !important;
                    display: flex;
                    height: 100%;
                    justify-content: center;
                    gap: 20px;
                    padding: 0.5rem;
                  "
                >
                  <b-icon-pencil
                    @click="findById(message.id)"
                    scale="1"
                    role="button"
                  />

                  <b-icon-x-circle
                    @click="deleteMessage(message.id)"
                    role="button"
                    style="color: red"
                    scale="1"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ServiceMessages from "../../services/serviceMessages";
import Input from "../UI/CustomInputs/Input.vue";
import InputSelect from "../UI/CustomInputs/InputSelect.vue";

export default {
  props: {
    defaultMessage: {
      type: String,
      default: "geral",
    },
  },
  data() {
    return {
      payloadMessage: {
        id: "",
        descricao: "",
        titulo: "",
        tipo: this.defaultMessage,
      },
      allMessages: [],
      messageTypes: [
        { text: "MIP", value: "mip" },
        { text: "Geral", value: "geral" },
      ],
    };
  },
  components: {
    Input,
    InputSelect,
  },
  methods: {
    async save() {
      try {
        await ServiceMessages.save(this.payloadMessage);
        this.getAllMessages();

        this.$emit("getNewMessage");

        return this.$toast.open({
          message: "Salvo com sucesso!",
          type: "success",
        });
      } catch (error) {
        return this.$toast.open({
          message:
            `${error.response.data.message || error.response.data.erros}` ||
            "Ocorreu um erro o salvar!",
          type: "info",
        });
      }
    },

    async update() {
      try {
        await ServiceMessages.update(this.payloadMessage);
        this.getAllMessages();

        this.$emit("getNewMessage");

        return this.$toast.open({
          message: "Atualizado com sucesso!",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            `${error.response.data.message || error.response.data.erros}` ||
            "Ocorreu um problema ao deletar!",
          type: "info",
        });
      }
    },

    async deleteMessage(id) {
      try {
        await ServiceMessages.delete(id);
        await this.getAllMessages();

        this.$emit("getNewMessage");

        return this.$toast.open({
          message: "deletado com sucesso!",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um problema ao deletar!",
          type: "info",
        });
      }
    },

    async findById(id) {
      const result = await ServiceMessages.findById(id);

      Object.assign(this.payloadMessage, result);

      this.$refs.tipo.valueItems = result.tipo;
      this.$refs.texto.valueInput = result.texto;
      this.$refs.titulo.valueInput = result.titulo;
    },

    async getAllMessages() {
      const result = await ServiceMessages.fillComobobox();
      this.allMessages = result;
    },

    async saveOrUpdate() {
      this.payloadMessage.id === "" ? await this.save() : await this.update();

      this.clear();
    },

    clear() {
      this.payloadMessage.id = "";
      this.payloadMessage.tipo = this.defaultMessage;
      this.payloadMessage.titulo = "";
      this.payloadMessage.texto = "";

      this.$refs.tipo.valueItems = this.defaultMessage;
      this.$refs.titulo.valueInput = "";
      this.$refs.texto.valueInput = "";
    },

    handleCloseModalAndClear() {
      this.clear();
      this.$bvModal.hide("modalMessages");
    },
  },
  mounted() {
    this.getAllMessages();
  },
  watch: {
    defaultMessage() {
      this.payloadMessage.tipo = this.defaultMessage;
    },
  },
};
</script>

<style scoped>
.styleHoverDelete:hover {
  background-color: #ff6347;
  border: solid 1px black;
}

.tabsContentSearch {
  overflow-y: scroll;
  max-height: 300px;
}

.btnsModal {
  border-radius: 5px;
  background-color: #006256;
  width: 165px;
  height: 28px;
  border: none;
  margin-top: 30px;
  color: white;
  font-size: 12px;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
}

.rowContainer {
  position: relative;
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 5px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.rowContainer span {
  font-weight: 600;
  font-size: 14px;
}

.ContentTable {
  display: flex;
  flex-direction: column;
  height: 50vh;
  max-height: 50vh;
  overflow: auto;
  width: 100%;
  max-width: 100%;
}

.titleNcm {
  margin-top: 30px;
  width: 100%;
  display: flex;
  font-size: 14px;
  font-weight: 600;
  color: #3a4750;
  justify-content: flex-start;
}

tr:nth-child(even) {
  background: #f2f3f3;
}

.headTable {
  color: whitesmoke;
  background: #3a4750;
  text-align: center;
  height: 30px;
}

.btnSave {
  background-color: transparent;
  border: solid 1px #0fbf4d;
  color: #0fbf4d;
}

.titleCard {
  margin-bottom: 32px !important;
  font-weight: 600;
  color: #666360;
  font-size: 16px;
}
</style>